"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListRow = void 0;
var React = require("react");
var translation_1 = require("@caddigital/sok-reducers/lib/utils/translation");
var sok_ui_1 = require("@caddigital/sok-ui");
var components_1 = require("components");
var ListRow = function (props) {
    var _a = React.useState(false), isConfirmationVisible = _a[0], setConfirmationVisible = _a[1];
    return (React.createElement("div", { className: "list-row" },
        React.createElement("div", null, props.item.name),
        isConfirmationVisible ? (React.createElement("div", { className: "confirmation" },
            React.createElement("div", { className: "confirmation-header" },
                React.createElement(sok_ui_1.Icon, { className: "fa-exclamation-triangle", prefix: 'fal' }),
                React.createElement("span", { className: "confirmation-title" }, (0, translation_1.getLocalization)('vektorio/modal/confirmation/remove'))),
            React.createElement("div", { className: "confirmation-buttons" },
                React.createElement(sok_ui_1.Button, { color: "red", onClick: function () { return props.remove(props.item); }, text: (0, translation_1.getLocalization)('global/yes') }),
                React.createElement(sok_ui_1.Button, { color: "dark-grey", onClick: function () { return setConfirmationVisible(false); }, text: (0, translation_1.getLocalization)('global/no') })))) : (React.createElement(components_1.TableRowIcon, { icon: 'fa-times-circle remove-icon', onClick: function () { return setConfirmationVisible(true); } }))));
};
exports.ListRow = ListRow;
